import React from 'react'

export const Sub = ({ children }) => (
  <sub style={{ lineHeight: 0 }}>{children}</sub>
)
export const Sup = ({ children }) => (
  <sup style={{ lineHeight: 0 }}>{children}</sup>
)
